import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "rounded-lg border border-slate-200 bg-white p-3 shadow-sm"
};
const _hoisted_2 = {
  class: "flex items-start justify-between gap-3"
};
const _hoisted_3 = {
  class: "min-w-0"
};
const _hoisted_4 = {
  class: "text-xs font-medium text-slate-500"
};
const _hoisted_5 = {
  class: "mt-1 truncate text-xl text-slate-900 money-text"
};
const _hoisted_6 = {
  key: 0,
  class: "mt-2 truncate text-xs text-slate-500"
};
import { computed } from 'vue';
export default {
  __name: 'WealthMetricCard',
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      default: '--'
    },
    description: {
      type: String,
      default: ''
    },
    tone: {
      type: String,
      default: 'slate'
    }
  },
  setup(__props) {
    const props = __props;
    const toneClass = computed(() => {
      const map = {
        primary: 'bg-primary-50 text-primary-600',
        emerald: 'status-badge is-success',
        amber: 'status-badge is-warning',
        red: 'status-badge is-danger',
        indigo: 'status-badge is-indigo',
        slate: 'status-badge is-neutral'
      };
      return map[props.tone] || map.primary;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString(__props.title), 1), _createElementVNode("p", _hoisted_5, _toDisplayString(__props.value), 1)]), _createElementVNode("div", {
        class: _normalizeClass(["flex h-9 w-9 items-center justify-center rounded-lg", toneClass.value])
      }, [_renderSlot(_ctx.$slots, "icon", {}, () => [_cache[0] || (_cache[0] = _createElementVNode("svg", {
        class: "h-5 w-5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M4 19h16M7 16V8m5 8V5m5 11v-6"
      })], -1))])], 2)]), __props.description ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.description), 1)) : _createCommentVNode("", true)]);
    };
  }
};